import { FC } from 'react';
import { FlexBox, ISidebarItemProps, RouteApp } from '@esg/ui';
import {
    sidebarConst
} from '../Constants';

const mainRoots: ISidebarItemProps[] = [
    ...sidebarConst
];

export const ManagementRoute: FC = () => {
    return (
        <FlexBox direction='column' padding={12}>
            <RouteApp
                routes={mainRoots}
            />
        </FlexBox>
    );
};
